import script from "./VerifyingMotion.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyingMotion.vue?vue&type=script&setup=true&lang=js"

import "./VerifyingMotion.vue?vue&type=style&index=0&id=41480f21&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src3621675308/src/competition/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41480f21"]])

export default __exports__